module.exports = __webpack_public_path__ + "static/media/slide-siding.ff8948ce.png";